// import
import Dashboard from "views/Dashboard/Dashboard.js";
import Tables from "views/Dashboard/Tables.js";
import Billing from "views/Dashboard/Billing.js";
import RTLPage from "views/RTL/RTLPage.js";
import Profile from "views/Dashboard/Profile.js";
import SignIn from "views/Pages/SignIn.js";
import SignUp from "views/Pages/SignUp.js";
import SignOut from "views/Pages/SignOut.js";
import Products from "views/Dashboard/Products";
import Orders from "views/Dashboard/Orders";
import ProductAccounts from "views/Dashboard/ProductAccounts";
import PurchasePlanner from "views/Dashboard/PurchasePlanner";
import ProductAnalytics from "views/Dashboard/ProductAnalytics";

import { FaShoppingBasket, FaFolderPlus, FaClipboardList, FaShareAlt } from "react-icons/fa";
import { FiAlertCircle, FiSettings } from "react-icons/fi";

export const OrderIcon = FaShoppingBasket;
import {
  HomeIcon,
  StatsIcon,
  CreditIcon,
  PersonIcon,
  DocumentIcon,
  RocketIcon,
  SupportIcon,
  ProductIcon,
} from "components/Icons/Icons";
import OrderDetails from "views/Dashboard/OrderDetails";
import Accounts from "views/Dashboard/Accounts";
import FreeZ from "views/Dashboard/FreeZ";
import DailyList from "views/Dashboard/DailyList";
import Settings from "views/Dashboard/Settings";
import Alerts from "views/Dashboard/Alerts";
import PriceDifferences from "views/Dashboard/PriceDifferences";
import ProductDetails from "views/Dashboard/ProductDetails";
import SharedAccounts from "views/Dashboard/SharedAccounts";
import SharedProductAccounts from "views/Dashboard/SharedProductAccounts";

var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "داشبورد",
    icon: <HomeIcon color="inherit" />,
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/products/:id/accounts",
    name: "Product Accounts",
    rtlName: "اکانت های محصول",
    icon: <ProductIcon color="inherit" />,
    component: ProductAccounts,
    layout: "/admin",
    hide: 1,
  },
  {
    path: "/products/:id/edit",
    name: "Edit Product",
    rtlName: "ویرایش محصول",
    component: ProductDetails,
    layout: "/admin",
    hide: 1,
  },
  {
    path: "/products/free-z",
    name: "Products Free Z",
    rtlName: "لیست موجودی",
    component: FreeZ,
    layout: "/admin",
    hide: 1,
  },
  {
    path: "/products/daily-list",
    name: "Daily Products List",
    rtlName: "لیست روزانه محتول",
    component: DailyList,
    layout: "/admin",
    hide: 1,
  },
  {
    path: "/products",
    name: "Products",
    rtlName: "محصولات",
    icon: <ProductIcon color="inherit" />,
    component: Products,
    layout: "/admin",
  },
  {
    path: "/orders/:id",
    name: "Show Order",
    rtlName: "سفارش",
    icon: <OrderIcon color="inherit" />,
    component: OrderDetails,
    layout: "/admin",
    hide: 1,
  },
  {
    path: "/orders",
    name: "Orders",
    rtlName: "سفارشات",
    icon: <OrderIcon color="inherit" />,
    component: Orders,
    layout: "/admin",
  },
  {
    path: "/accounts/shared/:productId",
    name: "Shared Product Accounts",
    rtlName: "Shared Product Accounts",
    icon: <FaShareAlt color="inherit" />,
    component: SharedProductAccounts,
    layout: "/admin",
    hide: 1,
  },
  {
    path: "/accounts/shared",
    name: "Shared Accounts",
    rtlName: "Shared Accounts",
    icon: <FaShareAlt color="inherit" />,
    component: SharedAccounts,
    layout: "/admin",
    hide: 1,
  },
  {
    path: "/accounts",
    name: "Accounts",
    rtlName: "اکانت ها",
    icon: <FaFolderPlus color="inherit" />,
    component: Accounts,
    layout: "/admin",
  },
  {
    path: "/settings",
    name: "Settings",
    rtlName: "تنظیمات",
    icon: <FiSettings color="inherit" />,
    component: Settings,
    layout: "/admin",
  },
  {
    path: "/alerts/price-differences",
    name: "Price Differences",
    rtlName: "اخطار اختلاف قیمت",
    component: PriceDifferences,
    layout: "/admin",
    hide: 1,
  },
  {
    path: "/alerts",
    name: "Alerts",
    rtlName: "اعلانات",
    icon: <FiAlertCircle color="inherit" />,
    component: Alerts,
    layout: "/admin",
  },
  {
    path: "/purchase-planner",
    name: "Purchase Planner",
    rtlName: "برنامه خرید",
    icon: <FaClipboardList color="inherit" />,
    component: PurchasePlanner,
    layout: "/admin",
  },
  {
    path: "/product-analytics",
    name: "Product Analytics",
    rtlName: "آمار محصولات",
    icon: <StatsIcon color="inherit" />,
    component: ProductAnalytics,
    layout: "/admin",
  },
  {
    path: "/tables",
    name: "Tables",
    rtlName: "جداول",
    icon: <StatsIcon color="inherit" />,
    component: Tables,
    layout: "/admin",
  },
  {
    path: "/billing",
    name: "Billing",
    rtlName: "صورت حساب",
    icon: <CreditIcon color="inherit" />,
    component: Billing,
    layout: "/admin",
  },
  {
    path: "/rtl-support-page",
    name: "RTL",
    rtlName: "راست چین",
    icon: <SupportIcon color="inherit" />,
    component: RTLPage,
    layout: "/rtl",
  },
  {
    name: "ACCOUNT PAGES",
    category: "account",
    rtlName: "صفحات",
    state: "pageCollapse",
    views: [
      {
        path: "/profile",
        name: "Profile",
        rtlName: "پروفایل",
        icon: <PersonIcon color="inherit" />,
        secondaryNavbar: true,
        component: Profile,
        layout: "/admin",
      },
      {
        path: "/signin",
        name: "Sign In",
        rtlName: "ورود",
        icon: <DocumentIcon color="inherit" />,
        component: SignIn,
        layout: "/auth",
        hide: true,
      },
      {
        path: "/signup",
        name: "Sign Up",
        rtlName: "ثبت نام",
        icon: <RocketIcon color="inherit" />,
        secondaryNavbar: true,
        component: SignUp,
        layout: "/auth",
        hide: true,
      },
      {
        path: "/signout",
        name: "Logout",
        rtlName: "خروج",
        icon: <RocketIcon color="inherit" />,
        component: SignOut,
        layout: "/auth",
      },
    ],
  },
];
export default dashRoutes;